import React, { useEffect } from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/HeroWhy";
import Whyhead from "../components/whyhead";
import WhyChooseGlamurPaints from "../components/WhyChooseGlamurPaints";
import FAQwhy from "../components/FAQwhy";
import Footer from "../components/Footer";
import ScrollToTopButton from "../components/ScrollToTopButton";
export default function Whychooseus() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Navbar />
      <Hero />
      <Whyhead />
      <WhyChooseGlamurPaints />
      <FAQwhy />
      <Footer />
      <ScrollToTopButton />
    </>
  );
}
